var scope_0 = require('/var/www/html/tectratechnologies.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698e7a3e503f0627532b181b0b5e941e.js').default;
var scope_1 = require('/var/www/html/tectratechnologies.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dcda177c2c3722ccefa8c3609e4cd004.js').default;
var scope_2 = require('/var/www/html/tectratechnologies.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    